import React from "react";
import { Download } from "lucide-react";
import type { RequirementsItem } from "../types";

interface ImportRequirementsCardProps {
  requirementsList: RequirementsItem[];
  onDownloadSample: () => void;
}

export const ImportRequirementsCard: React.FC<ImportRequirementsCardProps> = ({
  requirementsList,
  onDownloadSample,
}) => {
  return (
    <div className="lg:col-span-5 border border-slate-200 rounded-[20px] p-6 bg-white flex flex-col shadow-sm">
      <div className="flex items-center gap-3 pb-4 border-b border-slate-100 shrink-0">
        <div className="w-10 h-10 rounded-lg bg-[#FAF9FF] border border-[#A655F8]/10 flex items-center justify-center text-[#A655F8]">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
            <polyline points="14 2 14 8 20 8" />
          </svg>
        </div>
        <div>
          <h4 className="text-[18px] font-bold text-slate-800">CSV Format Requirements</h4>
          <p className="text-[14px] text-slate-400 font-normal">Your CSV file must include the following:</p>
        </div>
      </div>

      {/* Scrollable list of fields */}
      <div className="flex-grow max-h-[210px] overflow-y-auto pr-1 divide-y divide-slate-100/60 mt-3 scrollbar-thin">
        {requirementsList.map((req) => (
          <div key={req.field} className="py-2.5 flex items-center gap-3.5 first:pt-0 last:pb-0">
            {req.label === "Required" ? (
              <span className="bg-[#FAF5FF] text-[#A655F8] text-[12px] font-semibold px-2 py-0.5 rounded-[5px] shrink-0 w-[64px] text-center border border-[#A655F8]/10">
                Required
              </span>
            ) : (
              <span className="bg-slate-100 text-slate-500 text-[12px] font-semibold px-2 py-0.5 rounded-[5px] shrink-0 w-[64px] text-center">
                Optional
              </span>
            )}
            <div className="min-w-0">
              <span className="text-[16px] font-semibold text-slate-800 block leading-tight">{req.field}</span>
              <span className="text-[14px] text-slate-400 font-normal block truncate" title={req.desc}>
                {req.desc}
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* Download Sample CSV Card */}
      <button
        type="button"
        onClick={onDownloadSample}
        className="w-full mt-4 p-3.5 rounded-[12px] bg-[#F5F3FF] border border-[#A655F8]/5 hover:bg-[#F3F0FF]/60 flex items-center gap-3.5 text-left transition-colors focus:outline-none shrink-0 group"
      >
        <div className="w-9 h-9 rounded-full bg-[#EDE9FE] flex items-center justify-center text-[#A655F8] shrink-0 transition-transform group-hover:scale-105">
          <Download className="w-4.5 h-4.5 stroke-[2.5]" />
        </div>
        <div>
          <h5 className="text-[14px] font-semibold text-[#A655F8]">Download Sample CSV</h5>
          <p className="text-[12px] text-[#A655F8]/80 font-normal mt-0.5">Get a sample file to get started</p>
        </div>
      </button>
    </div>
  );
};
